import React from 'react';
import { Form, Input, Button, Row, Col } from 'antd';
import { PlusOutlined, MinusCircleOutlined } from '@ant-design/icons';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import MomentDatePicker from '../MomentDatePicker';

const { TextArea } = Input;

const SurgicalHistorySection = () => {
  const { t } = useTranslation();

  return (
    <Form.List name="surgicalHistory">
      {(fields, { add, remove }) => (
        <>
          {fields.map(({ key, name, ...restField }) => (
            <div key={key} className="medical-history-item">
              <Row gutter={[16, 0]}>
                <Col xs={24} sm={12}>
                  <Form.Item
                    {...restField}
                    name={[name, 'procedure']}
                    label={t('intake.medicalHistory.surgicalHistory.fields.procedure')}
                    rules={[
                      { required: true, message: t('intake.medicalHistory.surgicalHistory.validation.procedureRequired') },
                      { max: 200, message: t('intake.medicalHistory.surgicalHistory.validation.procedureMaxLength') }
                    ]}
                  >
                    <Input placeholder={t('intake.medicalHistory.surgicalHistory.placeholders.procedure')} />
                  </Form.Item>
                </Col>

                <Col xs={24} sm={6}>
                  <Form.Item
                    {...restField}
                    name={[name, 'date']}
                    label={t('intake.medicalHistory.surgicalHistory.fields.date')}
                  >
                    <MomentDatePicker
                      style={{ width: '100%' }}
                      placeholder={t('intake.medicalHistory.surgicalHistory.placeholders.selectDate')}
                      format="MM/DD/YYYY"
                      disabledDate={(current) => current && current > moment().endOf('day')}
                    />
                  </Form.Item>
                </Col>

                <Col xs={24} sm={6}>
                  <Form.Item
                    {...restField}
                    name={[name, 'hospital']}
                    label={t('intake.medicalHistory.surgicalHistory.fields.hospital')}
                  >
                    <Input placeholder={t('intake.medicalHistory.surgicalHistory.placeholders.hospital')} />
                  </Form.Item>
                </Col>
              </Row>

              <Row gutter={[16, 0]}>
                <Col xs={24} sm={12}>
                  <Form.Item
                    {...restField}
                    name={[name, 'complications']}
                    label={t('intake.medicalHistory.surgicalHistory.fields.complications')}
                  >
                    <TextArea
                      rows={2}
                      placeholder={t('intake.medicalHistory.surgicalHistory.placeholders.complications')}
                      maxLength={300}
                    />
                  </Form.Item>
                </Col>

                <Col xs={24} sm={12}>
                  <Form.Item
                    {...restField}
                    name={[name, 'notes']}
                    label={t('intake.medicalHistory.surgicalHistory.fields.notes')}
                  >
                    <TextArea
                      rows={2}
                      placeholder={t('intake.medicalHistory.surgicalHistory.placeholders.notes')}
                      maxLength={300}
                    />
                  </Form.Item>
                </Col>
              </Row>

              <div className="remove-item-button">
                <Button
                  type="text"
                  danger
                  icon={<MinusCircleOutlined />}
                  onClick={() => remove(name)}
                >
                  {t('intake.medicalHistory.surgicalHistory.buttons.remove')}
                </Button>
              </div>
            </div>
          ))}

          <Form.Item>
            <Button
              type="dashed"
              onClick={() => add()}
              block
              icon={<PlusOutlined />}
            >
              {t('intake.medicalHistory.surgicalHistory.buttons.add')}
            </Button>
          </Form.Item>

          {fields.length === 0 && (
            <div className="no-items-message">
              <p>{t('intake.placeholders.noSurgicalHistory')}</p>
            </div>
          )}
        </>
      )}
    </Form.List>
  );
};

export default SurgicalHistorySection;
